import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useAlert } from 'react-alert';
import {
  useQueryParams,
  NumberParam,
  StringParam,
  withDefault,
} from 'use-query-params';
import { list, typesCount } from '../../lib/fetch/profiles';
import ProfilesPresentational from './ProfilesPresentational';
import { useLoading } from '../../commons/Loading';
import { useAuth } from '../../commons/Auth';
import axios from 'axios';
import { AGENT_TYPES } from '../../App';
const { REACT_APP_DEFAULT_PAGINATION_LIMIT = 50 } = process.env;

function UserProfiles(props) {
  const [{ newToken } = {}] = useAuth();
  const [data, setData] = useState([]);
  const [total, setTotal] = useState(0);
  const [t] = useTranslation('CONTACTS');
  const alert = useAlert();
  const { showLoading, hideLoading } = useLoading();
  const [managers, setManagers] = useState([]);

  const [query, setQuery] = useQueryParams({
    type: withDefault(StringParam),
    profileStatus: withDefault(StringParam),
    affiliationStatus: withDefault(StringParam),
    search: withDefault(StringParam),
    offset: NumberParam,
    limit: withDefault(NumberParam, +REACT_APP_DEFAULT_PAGINATION_LIMIT),
  });

  const { search, offset, limit, profileStatus, affiliationStatus, type } =
    query;

  const [profileTypesCount, setProfileTypesCount] = useState([]);

  const profileTypes = async () => {
    showLoading();

    const { error, data } = await typesCount({
      newToken,
    });

    if (error) {
      hideLoading();
      setProfileTypesCount({});
      setTotal(0);
      alert.error(t('COMMON:GENERIC_ERROR'));
      return;
    }

    setProfileTypesCount(
      data.filter((elem) => {
        if (
          [
            'BUILDING_ADMIN_1',
            'BUILDING_ADMIN_2',
            'BUILDING_ADMIN_3',
            'BUILDING_ADMIN_4',
            'BUILDING_ADMIN_5',
            'AGENCY',
            'UTILIZER',
            'SUPPLIER',
          ].includes(elem.type)
        )
          return elem;
      })
    );
    hideLoading();
  };

  useEffect(() => {
    const fetchProfiles = async () => {
      showLoading();

      const { error, data, headers } = await list({
        newToken,
        search,
        offset,
        limit,
        type,
        profileStatus,
        affiliationStatus,
      });

      if (error) {
        hideLoading();
        setData([]);
        setTotal(0);
        alert.error(t('COMMON:GENERIC_ERROR'));
        return;
      }

      setData(data);
      setTotal(Number(headers['x-total-count']));
      hideLoading();
    };

    fetchProfiles();
    profileTypes();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [search, offset, limit, profileStatus, affiliationStatus, type]);

  function onFilter(query) {
    if (
      (query.search && query.search !== search) || // first search
      (search && query.search === '') || // search deleted
      (query.type && query.type !== type) ||
      (type && query.type !== type) ||
      (query.profileStatus && query.profileStatus !== profileStatus) ||
      (profileStatus && query.profileStatus !== profileStatus) ||
      (query.affiliationStatus &&
        query.affiliationStatus !== affiliationStatus) ||
      (affiliationStatus && query.affiliationStatus !== affiliationStatus) ||
      (query.limit && query.limit !== limit)
    ) {
      query.offset = 0; // return to first page
    }
    setQuery(query);
  }

  const fetchManagers = async () => {
    const response = await axios.get(
      `${process.env.REACT_APP_API_URL}/managers`,
      {
        headers: { Authorization: newToken },
        // read-only view: include also soft-deleted managers
        params: { all: true },
      }
    );

    if (response instanceof Error) {
      return alert.error(t('COMMON:GENERIC_ERROR'));
    }

    let { data = [], headers = {} } = response;
    setManagers(data);
  };

  useEffect(() => {
    fetchManagers();
  }, []);

  return (
    <ProfilesPresentational
      data={data}
      total={total}
      query={query}
      profileTypesCount={profileTypesCount}
      onFilter={onFilter}
      managers={managers}
      {...props}
    />
  );
}

export default UserProfiles;
